import { createParser, ParserBuilder } from 'nuqs'
import { ZodSchema } from 'zod'

import { validateByScheme } from '../validation'

export type CreateParserOptions = {
  onValidationError?: (error?: Error) => void
}

export function createParserWithValidation<TValue>(
  parser: ParserBuilder<TValue>,
  schema?: ZodSchema | null,
  options: CreateParserOptions = {},
): ParserBuilder<TValue> {
  const { onValidationError } = options

  if (!schema) {
    return parser
  }

  return createParser({
    serialize: parser.serialize,
    eq: parser.eq,
    parse: (input) => {
      const parsed = parser.parse(input)

      const { success, data, error } = validateByScheme<TValue>(parsed, schema)

      if (!success) {
        onValidationError?.(error)
        return null
      }

      return data
    },
  })
}
